import {
  Box,
  Button,
  Flex,
  Image,
  Tag,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
// import { BsCart2 } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAllProductsHome } from "../../../../Redux/App/action";
import { getNotifyMe } from "../../../../Redux/ProductController/action";

const AllProductData = ({ ProductCount }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const toast = useToast();
  const handleAvailable = () => {
    setIsButtonDisabled(true);
    toast({
      title: "Applied Success",
      description: "We Send Notification once product is available",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
  };
  const dispatch = useDispatch();
  const { allProductsHome } = useSelector((store) => store.appReducer);

  useEffect(() => {
    dispatch(getAllProductsHome);
  }, [dispatch]);
  const notifyMeHandler = (productId) => {
    dispatch(getNotifyMe(productId));
  };
  return (
    <Box
      w="full"
      alignItems="center"
      p={5}
      gap={5}
      display={"grid"}
      gridTemplateColumns={{ md: "repeat(4,1fr)", base: "repeat(1,1fr)" }}
    >
      {allProductsHome &&
        allProductsHome.slice(0, ProductCount).map((product, i) => (
          <Link key={i} to={`/productDetails/${product.productId}`}>
            <Box
              bg="white"
              maxW="sm"
              borderWidth="1px"
              rounded="lg"
              shadow="lg"
              position="relative"
            >
              <Image
                src={product.img}
                alt={"property.imageAlt"}
                w={"100%"}
                roundedTop="lg"
                // h={220}
              />
              <Box p="2">
                <Flex justifyContent={"space-between"}>
                  <Text
                    mt="1"
                    fontWeight="semibold"
                    as="h4"
                    lineHeight="tight"
                    noOfLines={1}
                  >
                    {product.productName}
                  </Text>
                  {product.variants[0].quantityAvailable === 0 ? (
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        toast({
                          title:
                            "We will notify you, when the product is available",
                          status: "success",
                          duration: 3000,
                          position: "top",
                          isClosable: true,
                        });
                        notifyMeHandler(product.productId);
                      }}
                      bg="#F52E7D"
                      fontSize={"13px"}
                      width={"80px"}
                      height={"30px"}
                      color={"white"}
                    >
                      Notify Me
                    </Button>
                  ) : (
                    <></>
                  )}
                </Flex>

                <Flex justifyContent={"space-between"}>
                  <Flex mt="2" gap={1}>
                    <Flex gap={2}>
                      <Text color={"#787A79"} fontWeight={"bold"}>
                        Price
                      </Text>
                      <Box textDecoration={"line-through"}>
                        ₹{product.priceDetails.price}
                      </Box>
                    </Flex>

                    <Box fontSize={"20px"} fontWeight={"semibold"}>
                      ₹{product.priceDetails.sellingPrice}
                    </Box>
                  </Flex>
                  {/* <Box
                    bg={"#E5E5E5"}
                    w={8}
                    p={1}
                    ml={10}
                    mt="2"
                    pl={"7px"}
                    borderRadius={"50%"}
                  >
                    <BsCart2 size={18} />
                  </Box> */}
                </Flex>
              </Box>
              {product.variants[0].quantityAvailable === 0 ? (
                <Box
                  position="absolute"
                  top="1"
                  left="1"
                  bg="black"
                  px={"7px"}
                  py={"4px"}
                  rounded="sm"
                  fontSize="10px"
                  fontWeight="bold"
                  color={"white"}
                >
                  SOLD OUT
                </Box>
              ) : (
                <Box
                  position="absolute"
                  top="1"
                  left="1"
                  bg="#1E9C99"
                  px={"13px"}
                  py={"2px"}
                  rounded="md"
                  fontSize="13px"
                  fontWeight="bold"
                  color={"white"}
                >
                  {`${product.priceDetails.discountPercentage}% Off`}
                </Box>
              )}
            </Box>
          </Link>
        ))}
    </Box>
  );
};

export default AllProductData;
